export const WHATSAPP_NUMBER = '16468066813'
export const PHONE_USA_DISPLAY = '+1 646 806 6813'
export const PHONE_PERU_DISPLAY = '+51 956 720 167'
export const EMAIL = 'yennilemon@gmail.com'
export const DOMAIN = 'yennidigital.com'

export const QUOTE_MESSAGE =
  'Hola Yenni, vi tu página de YenniDigital y me interesa solicitar una cotización para mi negocio.'

export const QUOTE_MESSAGE_SHORT =
  'Hola Yenni, vi tu página de YenniDigital y me interesa una cotización para mi negocio.'

export const SHOPIFY_MESSAGE =
  'Hola Yenni, vi tu página de YenniDigital y quiero vender online con una página conectada a mi tienda.'

export function whatsappUrl(message: string): string {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`
}
